/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Header_InvalidInputs */

const en_error_linesheet_header_invalid = /** @type {(inputs: Error_Linesheet_Header_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some values of the linesheet do not exist.`)
};

/**
* | output |
* | --- |
* | "Some values of the linesheet do not exist." |
*
* @param {Error_Linesheet_Header_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_header_invalid = /** @type {((inputs?: Error_Linesheet_Header_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Header_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_header_invalid(inputs)
});